import { Component, inject, input } from '@angular/core';
import { GoogleAnalyticsService } from '@shared-services/google-analytics.service';
import { CookieOptions, CookieService } from 'ngx-cookie-service';

declare function updateCrossDomainLinks(...args: any[]): void;

@Component({
    selector: 'fourd-cookie-notification',
    imports: [],
    templateUrl: './cookie-notification.component.html',
    providers: [CookieService]
})
export class CookieNotificationComponent {
  readonly brand = input<string>(undefined);

  private googleAnalyticsService = inject(GoogleAnalyticsService);
  private cookieService = inject(CookieService);

  readonly cookieKey: string = 'cc';
  readonly cookieValueConsent: string = 'c1';
  readonly cookieValueConsentAndLog: string = this.cookieValueConsent + 'l1';
  readonly cookieValueDeny: string = 'c0';
  readonly cookieValueDenyAndLog: string = this.cookieValueDeny + 'l1';
  readonly cookieExpiresDays: number = 365 / 2; // Use 6 months
  readonly cookieOptions: CookieOptions = { expires: this.cookieExpiresDays, path: '/', secure: true, sameSite: 'None' };

  show: boolean = false;

  constructor() {
    let cookieValue = this.cookieService?.get(this.cookieKey);
    if (!cookieValue) {
      this.show = true;
    } else {
      this.show = false;
    }    
  }

  closeAndAccept(event: Event): void {
    event?.stopPropagation();
    this.show = false;
    this.googleAnalyticsService?.emitConsentGranted();
    this.cookieService?.set(this.cookieKey, this.cookieValueConsent, this.cookieOptions);
    this.googleAnalyticsService?.logCookieDataConsent(true, (result) => {
      if (result) {
        this.cookieService?.set(this.cookieKey, this.cookieValueConsentAndLog, this.cookieOptions);
      }
    });
    this.googleAnalyticsService?.checkForClientId();
    if (this.updateCrossDomainLinksDefined()) {
      updateCrossDomainLinks(this.cookieValueConsent);
    }
  }

  closeAndReject(event: Event): void {
    event?.stopPropagation();
    this.show = false;
    this.googleAnalyticsService?.emitConsentDenied();
    this.cookieService?.set(this.cookieKey, this.cookieValueDeny, this.cookieOptions);
    this.googleAnalyticsService?.logCookieDataConsent(false, (result) => {
      if (result) {
        this.cookieService?.set(this.cookieKey, this.cookieValueDenyAndLog, this.cookieOptions);
      }
    });
    this.googleAnalyticsService?.checkForClientId();
    if (this.updateCrossDomainLinksDefined()) {
      updateCrossDomainLinks(this.cookieValueDeny);
    }
  }

  private updateCrossDomainLinksDefined(): boolean {
    return typeof updateCrossDomainLinks == 'function';
  }
}
